// import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { Table } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CiSaveDown2 } from "react-icons/ci";
import { CiUser, CiCalendarDate, CiDroplet, CiWavePulse1, CiVial, CiTempHigh } from "react-icons/ci";
import { useParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react';
import axios from 'axios';
export default function PatientInformation() {
    const [patientInformation, setPatientInformation] = useState({})
    const [timelineData, setTimelineData] = useState([])
    const { id } = useParams();
    console.log(id)
    const getDetails = () => {
        axios.get(`https://684e67d4f0c9c9848d280f2a.mockapi.io/patientlist?id=${id}`)
            .then(res => {
                console.log("response", res.data[0])
                setPatientInformation(res.data[0])
                setTimelineData(res.data[0].timelines)
            })
            .catch(err => {
                console.log("Error", err)
            })
    }
    function TimelineBlock() {
        return (
            <>
                {
                    timelineData.map(timelines => {
                        return (
                            <div className="timeline-item" key={timelines.date}>
                                <p className="timeline-date">on {timelines.date} at {timelines.time}</p>
                                <p className="consult-doctor mb-0">Consult with <span>{timelines.doctor}</span></p>
                                <p className="reports mb-0"><strong>Suggested Reports -</strong> <span>{timelines.reports.join(',')}</span></p>
                                <p className="medicine mb-0"><strong>Suggested Medicines -</strong> <span>{timelines.medicine.join(',')}</span></p>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    useEffect(() => {
        getDetails()
    }, [])
    return (
        <div className="patient-information-page">
            <Container fluid="md">
                <h2 className="mb-4">Patient Details</h2>
                <Link to="/doctor-dashboard" className="btn btn-link">Back to Dashboard</Link>
                <Row>
                    <Col lg={8} md={12}>
                        <div className="patient-information-banner mb-4">
                            <Row>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiUser />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.name}</p>
                                            <label>Patient Name</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiUser />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.gender}</p>
                                            <label>Gender</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiCalendarDate />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.age}</p>
                                            <label>Age</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiDroplet />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.bloodGroup}</p>
                                            <label>Blood Group</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiTempHigh />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.bplevel}</p>
                                            <label>BP Level</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiVial />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.sugarLavel}</p>
                                            <label>Sugar Level</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} md={4} sm={6}>
                                    <div className="d-flex align-items-center info-block pb-4">
                                        <div className="icon-box d-flex align-items-center justify-content-center flex-shrink-0">
                                            <CiWavePulse1 />
                                        </div>
                                        <div className="icon-info flex-grow-1 ps-3">
                                            <p>{patientInformation.heartRate}</p>
                                            <label>Heart Rate</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12}>
                                    <h5 className="mb-4"><span className="text-danger">Diseas Type : </span>{patientInformation.diseas}</h5>
                                </Col>
                                <Col lg={12} md={12} sm={12}>
                                    <h5 className="mb-4"><span className="text-danger">Diseas Department: </span>{patientInformation.depertment}</h5>
                                </Col>
                                <Col lg={12} md={12} sm={12}>
                                    <h5>Diseas Description</h5>
                                    <p>{patientInformation.diseaseDescription}</p>
                                    <p className="text-end">
                                        <Link to="../patient/consulting" state={{ patientInformation }} className='btn btn-info d-inline-flex align-items-center justify-content-center login-btn text-white'>Start Consulting</Link>
                                        {/* <button onClick={startConsulting} className='btn btn-info login-btn text-white'>Start Consulting</button> */}
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={4} md={12}>
                        <div className="patient-information-banner mb-4">
                            <h5 className="mb-4">Timelines</h5>
                            <div className="timeline-outer-wrap">

                                {
                                    timelineData.length > 0 ?
                                        <div className="timeline-container">
                                            <TimelineBlock />
                                        </div>
                                        :
                                        <p className="text-danger text-center">&#9888; &nbsp;No Timeline available</p>
                                }


                            </div>
                        </div>
                        <div className="patient-information-banner">
                            <h5>Reports</h5>
                            <Table responsive="sm" className="vertical-align-middle">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td><a rel="noreferrer" href='https://www.kgmu.org/download/meeting/5-IPD-Prescription.pdf' target='_blank'>Prescription</a></td>
                                        <td>20/04/2025</td>
                                        <td><a rel="noreferrer" href='https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' target='_blank' className="btn btn-link download-btn"><CiSaveDown2 /></a></td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td><a rel="noreferrer" href='https://www.kgmu.org/download/meeting/5-IPD-Prescription.pdf' target='_blank'>Blood Test Report</a></td>
                                        <td>25/04/2025</td>
                                        <td><a rel="noreferrer" href='https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' target='_blank' className="btn btn-link download-btn"><CiSaveDown2 /></a></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}